import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import moment from 'moment';
import _ from 'lodash';
import { loadMatches } from 'modules/Football/reducers/dailyMatches';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';

import CaretLink from 'modules/Common/components/CaretLink';
import FootballLiveCompetitionList from 'modules/Football/components/FootballLiveCompetitionList';

const REFRESH_INTERVAL_MILLIS = 10000;
const MAX_HOMEPAGE_FIXTURES = 6;

@layoutAsyncConnect(
  "HomeFootballLiveMatchesContainer",
  [
    {
      dispatch: () => loadMatches(),
      refreshInterval: REFRESH_INTERVAL_MILLIS,
      state: state => ({ competitions: state.football.dailyMatches })
    },
    userServiceLayoutConnect()
  ]
)
export default class HomeFootballLiveMatchesContainer extends Component {
  static propTypes = {
    matches: PropTypes.shape({
      matches: PropTypes.array
    }),
    competitions: PropTypes.object,
    children: PropTypes.node,
    dispatch: PropTypes.func.isRequired
  };

  now(format) {
    return moment().format(format);
  }

  // filter supplied competition object so that the output contains at most maxMatches matches,
  // however may competitions that requires
  filterTopCompetitions(comps, maxMatches) {
    let compIds = Object.keys(comps || {});
    const filteredComps = {};

    while(maxMatches > 0 && compIds.length) {
      const compId = compIds.shift(), comp = { ...comps[compId] };
      comp.matchList = _(comp.matchList).toPairs().take(maxMatches).fromPairs().value();
      const filteredMatches = _.size(comp.matchList);

      if (filteredMatches) {
        maxMatches -= filteredMatches;
        filteredComps[compId] = comp;
      }
    }

    return filteredComps;
  }

  render() {
    return (
      <div className="home-football-live-container">
        <div className="home-football-live-heading">
          <h3>Football Fixtures</h3>
          <h4>{this.now("Do MMMM YYYY")}</h4>
        </div>
        <FootballLiveCompetitionList competitionList={this.filterTopCompetitions(this.props.competitions.competitions, MAX_HOMEPAGE_FIXTURES)}/>
        <p><CaretLink to="/football/fixtures">All Football Fixtures</CaretLink></p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Home/containers/HomeFootballLiveMatchesContainer.js